import { render } from "./EditNavigationModal.vue?vue&type=template&id=4171a9f8&scoped=true"
import script from "./EditNavigationModal.vue?vue&type=script&lang=js"
export * from "./EditNavigationModal.vue?vue&type=script&lang=js"

import "./EditNavigationModal.vue?vue&type=style&index=0&id=4171a9f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4171a9f8"]])

export default __exports__